/**
 * `/logout-callback` — the post-logout redirect URI registered with Workspace, ported from
 * ipp-platform (apps/web/src/routes/LogoutCallbackPage.tsx).
 *
 * Workspace sends the browser here once it has ended the member's session on its side. It is
 * routed outside the AuthGate (main.tsx) because there is no session left to check — gated, a
 * member whose access token had not yet expired would be shown the back office instead.
 */
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { completeSignOut } from "@/auth/session";
import { AuthScreen } from "@/components/auth-gate";

export default function LogoutCallback() {
  const [params] = useSearchParams();
  const returnUrl = params.get("returnUrl");

  useEffect(() => {
    completeSignOut(returnUrl);
  }, [returnUrl]);

  return (
    <AuthScreen title="Signing out…">
      <p className="text-bank-muted text-sm">Your Workspace session has ended; clearing it here too.</p>
    </AuthScreen>
  );
}
